import { useRoleContext, useSwrFetch } from "hooks";

import { QuoteQA } from "./QuoteQA";

interface Props {
  quote: CondensedQuote;
}

export function QuoteQAContainer(props: Props) {
  const { quote } = props;
  const { role } = useRoleContext();

  const url = quote != null ? `/quotes/${quote.quote}/qa` : null;

  const { data, loading, error } = useSwrFetch<QuoteQA[]>({
    url,
    errorMessage: "Failed to fetch quote Q&A",
  });

  return (
    <QuoteQA
      loading={loading}
      error={error}
      renderSubmitQuestion={role?.type === "SHIPPER"}
      qaList={data ?? []}
      quote={quote}
    />
  );
}
